import React from 'react';
import { useSelector } from 'react-redux';
import { FooterLogo } from 'deckard-ui/dist/components/FooterLogo';
import styled from 'styled-components';
import { Container } from 'semantic-ui-react';
import * as appSelectors from 'app/state/app/app-selectors';
import * as cs from 'common/common-styles';
import { parseHTMLString } from 'utils/utility-functions';

const FooterWrapper = styled(Container)`
  ${cs.textBase}
  font-size: 14px;
  line-height: 1.5;
  margin-top: 33px;

  a {
    ${cs.linkCss}
  }
`;

const LogoWrapper = styled.div`
  margin-top: 2.5rem;
`;

const PrivacyTosLink = styled.a`
  text-decoration: underline;
  color: black !important;
`;

const PrivacyTosBase = styled.div`
  display: inline-block;
  width: 50%;
  font-size: 10px;
  margin-top: 0.1rem;
`;

const Privacy = styled(PrivacyTosBase)`
  padding-right: 1rem;
  text-align: right;
`;

const TermsOfService = styled(PrivacyTosBase)`
  padding-left: 1rem;
  text-align: left;
`;

export function Footer() {
  const stats = useSelector(appSelectors.stats);

  const footerText = stats?.app?.footerTextHtml;

  return (
    <FooterWrapper>
      {parseHTMLString(footerText)}
      <LogoWrapper>
        <FooterLogo />
      </LogoWrapper>
      <Privacy>
        <PrivacyTosLink as="a" href="https://app.termly.io/policy-viewer/policy.html?policyUUID=b6219f58-5bc6-4d88-8595-89887d2e0900" target="blank">
          Privacy Policy
        </PrivacyTosLink>
      </Privacy>
      <TermsOfService>
        <PrivacyTosLink as="a" href="https://deckardtech.github.io/policies/terms-of-service.pdf " target="blank">
          Terms of Service
        </PrivacyTosLink>
      </TermsOfService>
    </FooterWrapper>
  );
}

